import React, { useState, useEffect } from 'react';
import { translate } from '../Services/translation';
import uuid4 from "uuid4";

const EventList = ({ eventTags = [], events = [], eventsToShow = 0, selectedTag = null }) => {
    const showAll = selectedTag === null || !eventTags.some(tag => tag.toLowerCase() === selectedTag.toLowerCase());
    const preSelectedTags = new Array(eventTags.length).fill(false)

    if (selectedTag !== null && eventTags.some(tag => tag.toLowerCase() === selectedTag.toLowerCase())) {
        for (var i = 0; i < eventTags.length; i++) {
            if (eventTags[i].toLowerCase() == selectedTag.toLowerCase()) {
                preSelectedTags[i] = true;
            }
        }
    }

    const [filteredEvents, setFilteredEvents] = useState(events);
    const [eventsToShowState, setEventsToShowState] = useState(eventsToShow);
    const [allTagsClicked, setAllTagsClicked] = useState(showAll);
    const [selectedTags, setSelectedTags] = useState(preSelectedTags);
    const [selectedTagNames, setSelectedTagNames] = useState([selectedTag]);
    const [loadMoreNumber, setLoadMoreNumber] = useState(events.length - eventsToShow);

    useEffect(() => {
        for (var i = 0; i < selectedTags.length; i++) {
            let selectedTagName = eventTags[i];
            if (selectedTags[i] && !selectedTagNames.includes(selectedTagName)) {
                setSelectedTagNames(item => [...item, selectedTagName]);
            }
            if (!selectedTags[i] && selectedTagNames.includes(selectedTagName)) {
                setSelectedTagNames(selectedTagNames.filter(item => item !== selectedTagName));
            }
        }
    }, [selectedTags])

    useEffect(() => {
        if (!allTagsClicked) {
            setFilteredEvents(events.filter(event =>
                selectedTagNames.some(tagName =>
                    event.tags.some(tagNa => tagNa === tagName))));
        }
    }, [selectedTagNames])

    useEffect(() => {
        if (filteredEvents.length !== events.length) {
            if (filteredEvents.length < eventsToShow && filteredEvents.length != 0) {
                setLoadMoreNumber(0);
            } else {
                setLoadMoreNumber(events.length - eventsToShow);
            }
        }
    }, [filteredEvents])

    const handleLoadMore = (e) => {
        e.preventDefault();

        setEventsToShowState(events.length)
        setLoadMoreNumber(loadMoreNumber - eventsToShow > 0 ? loadMoreNumber - eventsToShow : 0)
    };

    const setTagHandler = (position) => {
        const updateSelectedTags = selectedTags.map((item, index) =>
            index === position ? !item : item
        );

        if (!updateSelectedTags.some(x => x == true) && !allTagsClicked) {
            setAllTagsClicked(true)
            setFilteredEvents(events);
            setSelectedTagNames([]);
            setSelectedTags(new Array(eventTags.length).fill(false));
            setLoadMoreNumber(events.length - eventsToShowState)
            return;
        }

        setSelectedTags(updateSelectedTags);
        setAllTagsClicked(false)
        setLoadMoreNumber(events.length - eventsToShowState)
    };

    const setAllTagHandler = () => {

        if (!selectedTags.some(x => x == true)) {
            if (!allTagsClicked) {
                setAllTagsClicked(!allTagsClicked)
            }
            return;
        }

        setAllTagsClicked(!allTagsClicked)
        if (filteredEvents.length <= events.length) {
            setFilteredEvents(events);
            setSelectedTagNames([]);
            setSelectedTags(new Array(eventTags.length).fill(false));
            setLoadMoreNumber(events.length - eventsToShowState)
            return;
        }
    };

    return (
        <div className="p-newspage__content">
            <div className="c-filterpills">
                <button type="button"
                    aria-pressed={allTagsClicked}
                    onClick={setAllTagHandler}>
                    {translate('eventList.all.text')}
                </button>
                {eventTags.length > 0 && eventTags.map((item, i) => (
                    <button
                        key={uuid4()}
                        type="button"
                        onClick={() => setTagHandler(i)}
                        aria-pressed={selectedTags[i]}>{item}
                    </button>
                ))}
            </div>

            <div className="c-newslist">
                {filteredEvents.length > 0 && filteredEvents.slice(0, eventsToShowState).map((item, i) => (
                    <div
                        key={uuid4()}
                        className={'c-newslist__item' + (item.isPushed && item.themeColorClass !== null ? ' c-newslist__item--hero' + item.themeColorClass : '') + (item.isPushed ? ' c-newslist__item--hero' + (i % 2 !== 0 ? ' left' : '') : '')}>
                        {item.image &&
                            <picture key={uuid4()}>
                                <img
                                    key={uuid4()}
                                    src={item.image.url}/>
                            </picture>
                        }
                        <div
                            key={uuid4()}
                            className="c-newslist__item__content">
                            {item.eventDate &&
                                <time key={uuid4()} dateTime={item.eventDate}>
                                    {new Date(item.eventDate).toISOString().substring(0, 10)}</time>
                            }
                            {item.tags.length > 0 &&
                                <div key={uuid4()} className="c-newslist__item__tags">
                                    {item.tags.map((tag, index) => (
                                        <span key={'tag'+index}>{tag}</span>
                                    ))}
                                </div>          
                            }
                            {item.url && item.title &&
                                <h2 key={uuid4()}>
                                    <a key={uuid4()} href={item.url}>{item.title}</a>
                                </h2>
                            }
                            {item.introduction &&
                                <p key={uuid4()}>{item.introduction}</p>
                            }
                            <div className="read-more">{translate('eventList.readmore')}</div>
                        </div>
                    </div>
                ))}
            </div>
            {loadMoreNumber > 0 &&
                <div className="c-newslist__handle">
                <button type="button" className="btn-black" onClick={handleLoadMore}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
                    </svg>
                    <span>{translate('eventList.showMore.text')} {'(' + loadMoreNumber + ')'}</span>
                </button>
                </div>
            }
        </div>
    );
}

export default EventList